import StickyNav from "@/components/landing/StickyNav";
import LandingFooter from "@/components/landing/LandingFooter";
import { cn } from "@/lib/utils";

function S({ className }: { className?: string }) {
  return (
    <div className={cn("rounded-xl bg-muted relative overflow-hidden", className)}>
      <div className="absolute inset-0 skeleton-shimmer" />
    </div>
  );
}

/** Content-only skeleton for pages that already render their own shell (StickyNav + Footer) */
export function LandingContentSkeleton() {
  return (
    <div className="animate-fade-in space-y-16 py-8">
      {/* Hero placeholder */}
      <div className="space-y-6 max-w-3xl mx-auto text-center">
        <S className="h-10 md:h-14 w-3/4 mx-auto" />
        <S className="h-5 w-2/3 mx-auto" />
        <S className="h-5 w-1/2 mx-auto" />
        <div className="flex justify-center gap-4 pt-2">
          <S className="h-12 w-36 rounded-full" />
          <S className="h-12 w-36 rounded-full hidden sm:block" />
        </div>
      </div>

      {/* Stats row */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="space-y-2 text-center">
            <S className="h-8 w-24 mx-auto" />
            <S className="h-4 w-20 mx-auto" />
          </div>
        ))}
      </div>

      {/* Feature cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="rounded-2xl border border-border p-6 space-y-4">
            <S className="h-10 w-10 rounded-lg" />
            <S className="h-5 w-3/4" />
            <S className="h-4 w-full" />
            <S className="h-4 w-2/3" />
          </div>
        ))}
      </div>

      {/* CTA block */}
      <div className="max-w-2xl mx-auto text-center space-y-4">
        <S className="h-8 w-64 mx-auto" />
        <S className="h-4 w-48 mx-auto" />
        <S className="h-12 w-40 mx-auto rounded-full" />
      </div>
    </div>
  );
}

/** Full-page skeleton with StickyNav + content + Footer */
export default function LandingShellSkeleton() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <StickyNav />
      <div className="flex-1 pt-16 px-6">
        <LandingContentSkeleton />
      </div>
      <LandingFooter />
    </div>
  );
}
